import type * as React from 'react';
import { post } from '@Domain/Api';
import secondFactorEnrollmentStarted, {
	type SecondFactorEnrollmentStartedAction,
	type SecondFactorEnrollmentStartedPayload,
} from '@Application/Security/Authentications/Actions/secondFactorEnrollmentStarted';
import secondFactorEnrollmentStartFailed, {
	type SecondFactorEnrollmentStartFailedAction,
} from '@Application/Security/Authentications/Actions/secondFactorEnrollmentStartFailed';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SecondFactorEnrollmentStartedAction | SecondFactorEnrollmentStartFailedAction;

/** No request body: the challenge cookie alone identifies the account pairing. */
export default () => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<SecondFactorEnrollmentStartedPayload>(
				`${parameters.api.host}/api/mfa/enrollment`,
				{},
				{ retryOnUnauthorized: false },
			);

			const action = secondFactorEnrollmentStarted(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = secondFactorEnrollmentStartFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
